import cx from 'classnames';
import {
    HOME_ESHOP_PILLS_MAIN,
} from 'mk/autogenerated/translations/BluePill.9faa185f1534ea14bb42d9764f7c385b'
import { Link } from 'mk2/components/Link';
import { LoadingPlaceholder } from 'mk2/components/LoadingPlaceholder';
import { Panel } from 'mk2/components/Panel';
import { PanelHeading } from 'mk2/components/PanelHeading';
import React from 'react';
import styles from './BluePill.mscss';

interface BluePillProps {
    className?: string;
    to: string;
    label: React.ReactNode;
}

export const BluePill: React.FunctionComponent<BluePillProps> = ({
    className,
    to,
    label,
}) => (
     <Link
         className={cx(
             styles.BluePill,
             className,
         )}
         to={to}
     >
        <span className={styles.BluePill__label}>
            {label}
        </span>
    </Link>
);

BluePill.displayName = 'BluePill';

interface PlaceholderOwnProps {
    className: string;
}

export const PillPlaceholder: React.FunctionComponent<PlaceholderOwnProps> = ({
    className,
}) => (
    <Panel className={cx(styles.StrollersPlaceholder, className)}>
        <PanelHeading
            title={HOME_ESHOP_PILLS_MAIN}
        />
        <div>
            <LoadingPlaceholder width={154} height={48} />
        </div>
    </Panel>
);

PillPlaceholder.displayName = 'PillPlaceholder';
